import { 
    apiGetInsertCaseList,
    apiInsertHouse ,
    apiInsertHouseImage,
    apiInsertHouseNoReview,
    apiBatchHouse,
    apiPublishHouse
} from "@/apis/api.js"; 
import { 
    uploadVideo
} from "@/apis/landlord/houseMgt.js"; 

/* 
  這邊可以改為用 types 物件取代 matutions_type.js (繼續用也可以)
  然後在前面加上模組名稱作為前綴，用來避免與其他模組重複。
  因為 action、mutation、和 getter 依然是註冊在全域的命名空間
*/
const types = {
    get_house_default: 'addHouse/get_house_default',
    set_house_list: 'addHouse/set_house_list',
    set_image_files: 'addHouse/set_image_files',
    set_cover: 'addHouse/set_cover',
    set_video: 'addHouse/set_video',
    set_save_fail: 'addHouse/set_save_fail',
    set_save_success: 'addHouse/set_save_success',
}

// count state 必須是 Object
const state = {
    houseDefaultList: [],
    houseList: [],
    imageFiles: [],
    cover: [],
    video: null,
    error: {
        state: false,
        msg: '儲存失敗，請再試一次'
    }
}

// getters 也可以整理到這邊直接返回 count 內容
const getters = {
    GET_FEATURES: (state) => {
        return state.houseDefaultList.features
    },
    GET_EQUIPS: (state) => {
        return state.houseDefaultList.equips
    },
    GET_RENT_INCLUDE: (state) => {
        return state.houseDefaultList.rentInclude
    },
    GET_BUILDING_TYPE: (state) => {
        return state.houseDefaultList.buildingTypeList
    },
    GET_HOUSE_TYPE: (state) => {
        return state.houseDefaultList.houseTypeList
    },
    GET_SPECIAL_TYPE: (state) => {
        return state.houseDefaultList.specialTypeList
    },
    GET_HOUSE_POLICY: (state) => {
        return state.houseDefaultList.caseHousePolicyDto.policySettingUseDtoList
    },
    GET_DESPOSIT_POLICY: (state) => {
        return state.houseDefaultList.caseDepositPolicyDto.policySettingUseDtoList
    },
    GET_SAVE_STATE: (state) => {
        return state.error
    },
    GET_HOUSE_HAS_IMAGE: (state) => {
        if(state.imageFiles.length > 0){
            return true
        }else{
            return false
        }
    },
    GET_HOUSE_HAS_COVER: (state) => {
        if(state.cover.length > 0){
            return true
        }else{
            return false
        }
    },
}

// actions 也是以 Object 形式建構。
const actions = {
    getHouseDefault ( {commit} ) {
        return new Promise((resolve, reject) => {
            apiGetInsertCaseList()
            .then(res => {
                // console.log(res)
                if( res.data.status == "SUCCESS" ){
                    let value = res.data.result
                    commit(types.get_house_default, value);
                    resolve()
                }
            })
            .catch(err => {
                reject(err)
            })
        })
    },
    setHouseList ( {commit}, data ) {
        return new Promise((resolve, reject) => {
            commit(types.set_house_list, data);
            resolve()
        })
    },
    setImageFiles ( {commit}, data ) {
        return new Promise((resolve, reject) => {
            commit(types.set_image_files, data);
            resolve()
        })
    },
    setCover ( {commit}, data ) {
        return new Promise((resolve, reject) => {
            commit(types.set_cover, data);
            resolve()
        })
    },
    saveHouse ( {commit, state, dispatch}, data ) {
        return new Promise((resolve, reject) => {
            console.log(data)
            // dispatch('saveImage')
            apiInsertHouse(data)
            .then(res => {
                console.log(res)
                if( res.data.status == "SUCCESS" ){
                    if(state.video && state.video.length > 0){
                        dispatch('saveVideo', res.data.result.houseCid )
                        .then( () => {
                        })
                    }
                    if(state.imageFiles.length > 0){
                        dispatch('saveImage', res.data.result.houseCid ).
                        then( () => {
                            dispatch('setImageFiles', [])
                            dispatch('setCover', [])
                            dispatch('setPublish', {houseCid: res.data.result.houseCid, status: 'REVEAL'})
                            resolve()
                        })
                    }else{
                        resolve()
                    }
                }else{
                    dispatch('setLoadingState', 0)
                    commit(types.set_save_fail, res.data.errorMsg)
                    reject()
                }
            })
            .catch(err => {
                reject(err)
            })
        })
    },
    saveHouseNoReview ( {commit, dispatch, state}, data ) {
        return new Promise((resolve, reject) => {
            console.log(data)
            apiInsertHouseNoReview(data)
            .then(res => {
                console.log('saveHouseNoReview',res)
                if( res.data.status == "SUCCESS" ){
                    if(state.video && state.video.length > 0){
                        dispatch('saveVideo', res.data.result.houseCid )
                        .then( () => {
                        })
                    }
                    if(state.imageFiles.length > 0  || state.cover.length > 0){
                        dispatch('saveImage', res.data.result.houseCid ).
                        then( () => {
                            dispatch('setImageFiles', [])
                            dispatch('setCover', [])

                            resolve()
                        })
                    }else{
                        resolve()
                    }
                }else{
                    dispatch('setLoadingState', 0)
                    commit(types.set_save_fail, res.data.errorMsg)
                    reject()
                }
            })
            .catch(err => {
                reject(err)
            })
        })
    },
    saveImage ( {commit, state, dispatch}, data ) {
        return new Promise((resolve, reject) => {
            let formData = new FormData();
            let houseCid = data,
                cover = state.cover.length?state.cover[0].file:null
            console.log('saveImageHouseCid', houseCid)
            formData.append('housesCid', houseCid);
            formData.append('headImage', cover);
            state.imageFiles.map( (image, index) => {
                formData.append('bodyImageArray', image.file);
            })
            apiBatchHouse(formData)
            .then(res => {
                console.log(res)
                if( res.data.status == "SUCCESS" ){
                    resolve()
                }else{
                    dispatch('setLoadingState', 0)
                    commit(types.set_save_fail, res.data.errorMsg)
                }
            })
            .catch(err => {
                reject(err)
            })
        })
    },
    setPublish( {commit, dispatch, state}, data ) {
        return new Promise((resolve, reject) => {
            // let obj = {
            //     "houseCid": state.houseCid,
            //     "status": data
            // }
            apiPublishHouse(data)
            .then(res => {
                console.log(res)
                if( res.data.status == "SUCCESS" ){
                    console.log(data)
                    
                    resolve()
                }else{
                    dispatch('setLoadingState', 0)
                    commit(types.set_save_fail, {status: true, msg: res.data.errorMsg})
                }
            })
            .catch(err => {
                reject(err)
            })
        })
    },
    saveVideo ( {commit, state, dispatch}, data ) {
        return new Promise((resolve, reject) => {
            let formData = new FormData();
            let houseCid = data,
            houseFilm = state.video.length?state.video[0].file:null

            formData.append('houseCid', houseCid);
            formData.append('houseFilm', houseFilm);
            uploadVideo(formData)
            .then(res => {
                console.log(res)
                if( res.data.status == "SUCCESS" ){
                    resolve()
                }else{
                    dispatch('setLoadingState', 0)
                    dispatch('setAlarmStatus', {status: true,title: res.data.errorMsg,type: 'error'})
                }
            })
            .catch(err => {
                reject(err)
            })
        })
    },
    setVideo( {commit}, data ) {
        return new Promise((resolve, reject) => {
            commit(types.set_video, data);
        })
    },
}

// mutations
const mutations = {
    [types.get_house_default](state, data){
        state.houseDefaultList = data
    },
    [types.set_house_list](state, data){
        state.houseList = data
    },
    [types.set_image_files](state, data){
        state.imageFiles = data
    },
    [types.set_cover](state, data){
        state.cover = data
    },
    [types.set_video](state, data){
        state.video = data
    },
    [types.set_save_fail](state, data){
        state.error.state = true
        state.error.msg = data
    },
    [types.set_save_success](state){
        state.error.state = false
        state.error.msg = ''
    },
}

/*
因為我們把 vuex 所有職權都寫在同一隻檔案，
所以必須要 export 出去給最外層 index.js 組合使用
*/
export default {
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/landlord/addHouse.js